export default __webpack_public_path__ + "static/img2-ac9dde3021734956fee93c640a6f5d45.jpg";